import type { TFunction } from "i18next"
import { z } from "zod"

export const forgotPasswordFormSchema = (t: TFunction) =>
  z.object({
    email: z
      .string()
      .email({ message: t("validation.invalidEmail") }),
  })
export type ForgotPasswordFormSchemaProps = z.infer<
  ReturnType<typeof forgotPasswordFormSchema>
>
